export default "<app-home></app-home>\r\n";